import { type PaymentMethodCategoryType } from '@webapp/platform/banking/entities/enums/PaymentMethodCategoryEnum'
import { type BeneficiaryFormConfig } from '../types'

export const PAYMENT_METHOD_CATEGORY_CONFIGS: Record<
  PaymentMethodCategoryType,
  BeneficiaryFormConfig | null
> = {
  US_DOMESTIC: {
    defaultValues: {
      beneficiary: {
        entity_type: 'COMPANY',
        bank_details: {
          account_currency: 'USD',
          bank_country_code: 'US',
        },
      },
      transfer_methods: ['LOCAL'],
    },
    customizations: {
      fields: {
        'beneficiary.entity_type': { hidden: true },
        'beneficiary.bank_details.account_currency': { hidden: true },
        'beneficiary.bank_details.bank_country_code': { hidden: true },
      },
      ui: {
        hideFeeConfig: true,
        hideFlightTime: true,
      },
    },
  },
  CANADIAN_DOMESTIC: {
    defaultValues: {
      beneficiary: {
        entity_type: 'COMPANY',
        bank_details: {
          account_currency: 'CAD',
          bank_country_code: 'CA',
          local_clearing_system: 'EFT',
        },
      },
      transfer_methods: ['LOCAL'],
    },
    customizations: {
      fields: {
        'beneficiary.entity_type': { hidden: true },
        'beneficiary.bank_details.account_currency': { hidden: true },
        'beneficiary.bank_details.bank_country_code': { hidden: true },
        'beneficiary.bank_details.local_clearing_system': { hidden: true },
      },
      ui: {
        hideFeeConfig: true,
        hideFlightTime: true,
      },
    },
  },
  INTERNATIONAL_US: {
    defaultValues: {
      beneficiary: {
        entity_type: 'COMPANY',
      },
      transfer_methods: ['LOCAL', 'SWIFT'],
    },
    customizations: {
      fields: {
        'beneficiary.entity_type': { hidden: true },
      },
      ui: {
        hideFeeConfig: true,
        hideFlightTime: true,
      },
    },
  },
  EXTERNAL: null, // No Airwallex config
}
